import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pap-completed',
  templateUrl: 'pap-completed.component.html',
  styleUrls: ['./pap-completed.component.less', '../../shared/common.less'],
})

export class PapCompletedComponent implements OnInit {
  @Input() step: number = 1;
  @Output() toPapVerification = new EventEmitter();
  @Output() toCerfaVerification = new EventEmitter();
  @Output() toCerfaCreation = new EventEmitter();
  @Output() toPollCreation = new EventEmitter();


  backToPapVerification() {
    this.toPapVerification.emit();
  }

  backToCerfaVerification() {
    this.toCerfaVerification.emit();
  }
  goToCerfaCreation() {
    this.toCerfaCreation.emit();
  }

  goToPollCreation() {
    this.toPollCreation.emit();
  }

  ngOnInit(): void {
  }
}
